import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ServiceWorkerUpdateHandler = () => {
	const location = useLocation();

	useEffect(() => {
		// Check if SW update is pending on every route change
		if (sessionStorage.getItem('sw-update-pending') === 'true') {
			sessionStorage.removeItem('sw-update-pending');
			window.location.reload();
		}
	}, [location.pathname, location.search]); // Trigger on route changes

	return null; // This component doesn't render anything
};

export default ServiceWorkerUpdateHandler;
